import { Shield } from 'lucide-react';
import { LicenseAdminPanel } from '../components/organisms';

export function LicenseAdminPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <div className="flex items-center gap-3">
          <Shield
            className="
              size-7 text-action-primary
              dark:text-text-accent
            "
          />
          <h1 className="text-2xl font-bold text-text-primary" data-testid="license-admin-heading">
            License Management
          </h1>
        </div>
        <p className="mt-2 text-sm text-text-secondary">
          View your current license status, upload a new license, or remove the existing one.
        </p>
      </div>
      <LicenseAdminPanel />
    </div>
  );
}
